import { render, staticRenderFns } from "./ObjectPricing.vue?vue&type=template&id=e436637a&scoped=true"
import script from "./ObjectPricing.vue?vue&type=script&lang=js"
export * from "./ObjectPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e436637a",
  null
  
)

export default component.exports